export default {"src":"/_next/static/media/favicon.e5ed5fc7.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};